<template>
<div class="mt-3" v-if="biens.length > 0">
    <div class="flex justify-between items-center bg-indigo-600 rounded-lg py-2 px-3">
        <h2 class="text-white text-sm font-semibold">Total par bien</h2>
    </div>
    <div class="px-2 py-3">
        <table class="w-full text-sm">
            <tbody>
                <tr v-for="bien in biens" :key="bien.uuid" class="border-b border-gray-100 dark:border-gray-800 last:border-0">
                    <td class="py-1.5 text-gray-600 dark:text-gray-300">{{ bien.libelle }}</td>
                    <td class="py-1.5 text-right font-medium" :class="bien.total >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'">{{ format(bien.total) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
export default {
    props: {
        biens: {
            type: Array,
            default: () => []
        }
    },

    methods: {
        format(value) {
            return `${Number(value || 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} €`;
        }
    }
};
</script>
